import { useCallback } from 'react';
import {
  getLeaveStatusesDictSelector,
  getPassportStatusesDictSelector,
  getITReqStatusesSelector,
  getSalaryStatusesDictSelector,
  getRequisitionStatusesDictSelector,
  getOverseasStatusesDictSelector,
  getResumptionStatusesDict,
  getAttendanceStatusesDict,
  getResignationStatusesDict,
  getPurchaseStatusesDictSelector,
  getRFQStatusDict,
} from '@Store/selectors/dictionarySelector';
import { TypeDict } from 'types';
import RequestType from '@Types/common/RequestTypes';
import { useAppSelector } from '.';

interface ReturnedValue {
  findStatus: (statusNum: number) => TypeDict | undefined;
}

const mapperStatusesDictionary = {
  Leave: getLeaveStatusesDictSelector,
  Passport: getPassportStatusesDictSelector,
  Salary: getSalaryStatusesDictSelector,
  ITRequisition: getITReqStatusesSelector,
  Material: getRequisitionStatusesDictSelector,
  Purchase: getPurchaseStatusesDictSelector,
  Overseas: getOverseasStatusesDictSelector,
  Resumption: getResumptionStatusesDict,
  Attendance: getAttendanceStatusesDict,
  // TODO: MOCK REPLACE
  AttendanceProfile: getAttendanceStatusesDict,
  Resignation: getResignationStatusesDict,
  Tender: getRFQStatusDict,
  ESSTaskRequest: getLeaveStatusesDictSelector,
  MRTaskRequest: getRequisitionStatusesDictSelector,
};

const useStatusFinderByNum = (requestType: RequestType): ReturnedValue => {
  const dictionaryStatuses = useAppSelector(
    mapperStatusesDictionary[requestType]
  );

  const findStatus = useCallback(
    (statusNum: number): TypeDict | undefined =>
      dictionaryStatuses.find((item) => item.codeNum === statusNum),
    [dictionaryStatuses]
  );

  return { findStatus };
};

export default useStatusFinderByNum;
